// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"189":"5a7212bb","507":"1ec16022","540":"a3522017","553":"11ef4335","589":"1eb4a3c3","623":"5d00e248","668":"ea3b00cc","767":"f36da017","803":"e7f04356","851":"a1fe7d92","917":"cb07aba8","984":"0d624a98","988":"d569d43a"}[chunkId] + ".chunk.js";
};